module.exports = "/static/assets/4b40b0a415a9776ae5413d1c6d7e63fc.png";